import { render, staticRenderFns } from "./AddImageModal.vue?vue&type=template&id=b34c1322"
import script from "./AddImageModal.vue?vue&type=script&lang=js"
export * from "./AddImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports